import React from 'react';

function amountToWords(amount) {
  const words = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tensWords = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  function convertToWords(num) {
    if (num < 20) return words[num];
    const digit = num % 10;
    return tensWords[Math.floor(num / 10)] + (digit ? ' ' + words[digit] : '');
  }

  function convertThreeDigits(num) {
    const hundred = Math.floor(num / 100);
    const remainder = num % 100;
    let result = '';
    if (hundred) {
      result += words[hundred] + ' Hundred';
    }
    if (remainder) {
      if (result !== '') result += ' ';
      result += convertToWords(remainder);
    }
    return result;
  }

  if (isNaN(amount)) return 'Invalid Input';
  if (amount === 0) return 'Zero';

  const suffixes = ['', 'Thousand', 'Million', 'Billion', 'Trillion', 'Quadrillion', 'Quintillion'];

  let result = '';
  let i = 0;
  while (amount > 0) {
    if (amount % 1000 !== 0) {
      result = convertThreeDigits(amount % 1000) + ' ' + suffixes[i] + ' ' + result;
    }
    amount = Math.floor(amount / 1000);
    i++;
  }

  return result.trim();
}

function AmountInWords({ amount }) {
  const amountInWords = amountToWords(amount);

  return (
    <span> {amountInWords} {'only'}</span>
  );
}

export default AmountInWords;
